import { Link } from "react-router-dom";
import { Instagram, Facebook, Twitter } from "lucide-react";
import BrandMark from "@/components/BrandMark";

const Footer = () => {
  return (
    <footer data-testid="site-footer" className="border-t border-white/5 bg-[#080808] mt-24">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 py-20">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12">
          <div className="md:col-span-5">
            <div className="mb-6">
              <BrandMark size="lg" />
            </div>
            <p className="font-body text-[#8A8A85] leading-relaxed max-w-md text-sm font-light">
              A house of artisanal blends. Single-origin spices, slow-toasted in small
              batches, and shipped within seven days of grinding.
            </p>
          </div>

          <div className="md:col-span-2">
            <div className="overline mb-5">Explore</div>
            <ul className="space-y-3">
              {[
                { to: "/shop", label: "Shop" },
                { to: "/about", label: "Our Story" },
                { to: "/", label: "Home" },
              ].map((l) => (
                <li key={l.to}>
                  <Link
                    to={l.to}
                    className="text-sm text-[#F5F5F0]/70 hover:text-[#D4AF37] transition-colors"
                  >
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-2">
            <div className="overline mb-5">Atelier</div>
            <ul className="space-y-3 text-sm text-[#F5F5F0]/70">
              <li>Chennai, India</li>
              <li>hello@smartpremium.in</li>
              <li>+91 90000 00000</li>
            </ul>
          </div>

          <div className="md:col-span-3">
            <div className="overline mb-5">Follow</div>
            <div className="flex items-center gap-5">
              <a href="#" aria-label="Instagram" className="text-[#F5F5F0]/70 hover:text-[#D4AF37] transition-colors">
                <Instagram size={18} strokeWidth={1.4} />
              </a>
              <a href="#" aria-label="Facebook" className="text-[#F5F5F0]/70 hover:text-[#D4AF37] transition-colors">
                <Facebook size={18} strokeWidth={1.4} />
              </a>
              <a href="#" aria-label="Twitter" className="text-[#F5F5F0]/70 hover:text-[#D4AF37] transition-colors">
                <Twitter size={18} strokeWidth={1.4} />
              </a>
            </div>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-white/5 flex flex-col md:flex-row items-start md:items-center justify-between gap-4">
          <p className="text-xs text-[#8A8A85] tracking-wider">
            © {new Date().getFullYear()} Smart Premium Spices. All rights reserved.
          </p>
          <p className="text-xs text-[#8A8A85] tracking-wider">
            Crafted with patience, in Tamil Nadu.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
